<template>
  <div>
    <VLayout
      wrap
      class="fullWidth logoContainer"
    >
      <V-Flex
        class="secondary"
        sm12
        md7
        style="padding: 90px 0 70px 0;"
      >
        <div
          class="pacifico primary--text text-xs-center mb-4"
          style="font-size: 26px;"
        >
          Teljes körű nyomdai szolgáltatás 1989 óta
        </div>

        <div class="white--text text-xs-center font-weight-bold mb-5 slogen">
          Professional<br>
          Printing<br>
          Solutions
        </div>

        <VLayout justify-center>
          <VBtn
            :to="{ name: 'About' }"
            color="primary"
            class="font-weight-medium"
            style="width: 200px; height: 70px; border-radius: 15px;"
          >
            Rólunk
          </VBtn>
        </VLayout>
      </V-Flex>

      <V-Flex
        sm12
        md5
        class="pantoneScale"
      >
        <img
          src="@/assets/kppslogen.svg"
          alt="Körös Print-Pack Kft. Logo"
        >
      </V-Flex>
    </VLayout>

    <VLayout
      class="mt-4"
      justify-center
      wrap
      style="max-width: 1400px; margin: auto;"
    >
      <VChip
        v-for="(tag, index) in tags"
        :key="index"
        color="primary"
        text-color="white"
        label
        class="font-weight-medium"
        style="height: 45px; font-size: 16px; text-transform: uppercase;"
      >
        {{ tag }}
      </VChip>
    </VLayout>
  </div>
</template>

<script>
export default {
  name: 'Home',
  metaInfo: {
    title: 'Professional Printing Solutions | Körös PRINT-PACK Kft.',
    meta: [
      {
        name: 'description',
        content: 'Professzionális nyomdai szolgáltatások 30 éve. Igényes kivitelű faltkarton dobozok, reklámanyagok és íves címkék gyártása.',
      },
    ],
  },
  data: () => ({
    tags: [
      'Doboztervezés',
      'Ívkasírozás',
      'Virtuális modellezés',
      'Braille nyomtatás',
      'Ofszetnyomtatás',
      'Melegfóliázás',
      'Bliszter lakkozás',
      'Stancolás',
      'Diszperziós lakkozás',
      'Dombornyomás',
      'UV lakkozás',
      'Fémprégelés',
      'Dobozragasztás',
      'Proofnyomtatás',
      'Ablakozás',
      'Íves címkegyártás',
      'Ofszet lakkozás',
      'Nyomtatás fémgőzölt kartonra',
      'ív ezüst és arany melegfóliázása',
    ],
  }),
};
</script>

<style scoped>
.slogen {
  font-size: 86px;
  line-height: 1;
}

@media (max-width: 600px) {
  .slogen {
    font-size: 44px;
  }
}

.pantoneScale {
  background-image: url('../assets/pantone-scale.jpg');
  background-position: center;
  background-repeat: no-repeat;
  align-content: center;
  justify-content: center;
  display: flex;
  min-height: 600px;
}

.pantoneScale img {
  width: 75%;
  height: 100%;
  max-width: 75vw;
}

@media (min-width: 2561px) {
  .logoContainer {
    margin: auto;
  }
}

.logoContainer {
  max-width: 2560px !important;
}
</style>
